import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';

import userInfo from './userInfo';
import statesOption from './statesOption';
import orders from './orders';
import modals from './modals';
import lookup from './lookup';

const rootReducer = combineReducers({
  userInfo,
  statesOption,
  orders,
  modals,
  form: formReducer,
  routing: routerReducer,
  lookup,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js